module.exports = __webpack_public_path__ + "img/ISO9001-en.268a1c56.jpg";